/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Variant_AddInputs */

const vi_shop_variant_add = /** @type {(inputs: Shop_Variant_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm loại`)
};

/**

* @param {Shop_Variant_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_variant_add = /** @type {((inputs?: Shop_Variant_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Variant_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_variant_add(inputs)
});